var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemChannelVimeo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M4.65 9.664s1.34-1.06 1.787-.53 2.152 6.925 2.721 8.105c.497 1.035 1.868 2.403 3.37 1.426S19.027 13.41 19.92 8.36c.894-5.049-6.01-3.991-6.742.408 1.828-1.1 2.803.447 1.868 2.2-.934 1.75-1.787 2.892-2.234 2.892-.445 0-.789-1.172-1.3-3.22-.528-2.116-.524-5.93-2.72-5.497C6.722 5.55 4 8.809 4 8.809z"
})));
export default SvgGemChannelVimeo;